import list from './list'
import create from './create'
import update from './update'
import show from './show'
import del from './delete'
import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    domainOptions: []
  },
  getters: {
    getDomainOptions (state) {
      return state.domainOptions.map(domain => {
        return { value: domain.domain, text: domain.domain }
      })
    }
  },
  mutations: {
    setDomainOptions (state, payload) {
      state.domainOptions = payload
    }
  },
  actions: {
    async fetchDomainOptions ({ commit }) {
      let params = {
        pagination: false
      }
      const response = await new ApiService('domains', params).getResults()
      commit('setDomainOptions', response.items)
    }
  },
  modules: {
    list,
    create,
    update,
    show,
    del
  }
}
